import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

interface PAYLOAD_PROPS {
  campaignTitle: string;
  endDate: string;
  couponCode: string;
  percentageDiscount: number;
  startDate: string;
}

export default class ExperimentSplashPageDiscountLabel {
  static key = 'splash-page-discount-label';

  static variations = {
    control: 'control',
    'show-splashpage-discount-label': 'show-splashpage-discount-label',
  };
  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }
  static isShowSplashpageDiscountLabel(): boolean {
    return (
      this.currentVariant() ===
      this.variations['show-splashpage-discount-label']
    );
  }

  static payload: PAYLOAD_PROPS[] = null;

  static currentVariant(): string {
    const { payload, value } = getFullVariant(this.key, {
      value: this.variations['control'],
    });

    this.payload = payload;

    return value;
  }
}
